import { useSelector } from "react-redux";
import { getWhiteLabel } from "store/whiteLabel/selectors";
import { isGsDomain } from "services/whiteLabels";
import { gsQualificationQuestion } from "@gs/core/domain/Whitelabel/QualificationQuestion";

export const useQualificationQuestions = () => {
  const whiteLabel = useSelector(getWhiteLabel);
  const qualificationQuestions = whiteLabel.status === "ready" && whiteLabel.qualificationQuestions;
  if (isGsDomain()) return gsQualificationQuestion;
  return qualificationQuestions || null;
};
